export default __webpack_public_path__ + "static/media/paprika_jancsi_etterem_11.b02bdac5.JPG";